import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { initialDictionariesErrorStyles } from './styles.ts';

type TInitialDictionariesErrorProps = {
  isRetrying: boolean;
  onRetry: () => void;
};

const InitialDictionariesError = ({ isRetrying, onRetry }: TInitialDictionariesErrorProps) => (
  <Box sx={initialDictionariesErrorStyles.root}>
    <Typography variant="h6">Не вдалося завантажити дані для заповнення гарантії.</Typography>
    <Typography color="text.secondary">Спробуйте ще раз.</Typography>
    <Button
      disabled={isRetrying}
      onClick={onRetry}
      startIcon={isRetrying ? <CircularProgress size={18} color="inherit" /> : undefined}
      variant="contained"
    >
      Спробувати ще раз
    </Button>
  </Box>
);

export default InitialDictionariesError;
